import { navigate, RouteComponentProps, useLocation } from '@reach/router';
import React from 'react';
import { WidgetBreadcrumb } from '../../../interfaces/internal';
import { useOvermindState } from '../../state';
import { SubPage } from '../SubPage/SubPage';
import { WidgetProps } from '../Widget/Widget';
import { useTranslation } from 'react-i18next';

interface StockEquipmentOwnProps extends RouteComponentProps {
    widget: WidgetProps;
    children: React.ReactNode;
}

type StockEquipmentProps = StockEquipmentOwnProps;

const handleCloseClick = async () => {
    const splittedPath = window.location.pathname.split('/');
    if (splittedPath.length >= 3) {
        await navigate(`/${splittedPath[1]}`);
    } else {
        await navigate('/');
    }
};

export const StockEquipment: React.FC<StockEquipmentProps> = ({ children, widget }: StockEquipmentProps) => {
    const { t } = useTranslation('StockEquipment');
    const { selectedStockEquipment } = useOvermindState();
    const { pathname } = useLocation();
    const isRegisterPage = pathname.endsWith('/register');
    const isTableView = pathname === `/stock-equipment` || pathname === `/stock-equipment/`;

    const breadcrumb: WidgetBreadcrumb = {
        id: widget.id,
        title: widget.title,
        subPage: isRegisterPage
            ? {
                  icon: null,
                  title: t('Create stock equipment'),
              }
            : selectedStockEquipment !== null && !isTableView
            ? {
                  icon: '',
                  title: t('Stock equipment details'),
              }
            : undefined,
    };

    return (
        <SubPage breadcrumb={breadcrumb} onCloseClick={handleCloseClick} idSlug={widget.id}>
            {children}
        </SubPage>
    );
};
